module.exports = __webpack_public_path__ + "static/img/BjMizcon2023_web_banner_mobile.f21bde4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/component/BjMizcon2023_web_banner_mobile.png
// module id = XQEl
// module chunks = 64